module.exports = __webpack_public_path__ + "img/transaction.b14131a8.svg";